import { RichTextBlock } from "graphql/generated-types";

const RichText = ({ block }: { block: RichTextBlock }) => {
	return (
		<article className="container grid-cols-3 lg:grid">
			<div className="prose col-span-2 max-w-none lg:text-lg" dangerouslySetInnerHTML={{ __html: block.value }} />
		</article>
	);
};

export default RichText;
